
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thank-you-for-your-order",
      function () {
        return require("private-next-pages/thank-you-for-your-order.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thank-you-for-your-order"])
      });
    }
  